import { DialogActions, Backdrop, Box, Grid, TextField, Container, Typography, Dialog, DialogTitle, Paper, Card, CardContent, Chip, Divider, IconButton, Switch, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import MiSlider from './MiSlider';
import Tabla from './Tabla';
import EmpresaFind from './EmpresaFind';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Sync';
import Invertir from './Invertir';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import AlertTitle from '@mui/material/AlertTitle';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import LockIcon from '@mui/icons-material/Lock';
import EditIcon from '@mui/icons-material/Edit';
import InvertidoIcon from '@mui/icons-material/Paid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import "../css/Busqueda.css"

import useAuth from '../hooks/useAuth';
import axios from '../api/axios';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
var registroActual = null

export default function Busqueda() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    const [empresa, setEmpresa] = React.useState(0);
    const [filtroBalance, setFiltroBalance] = React.useState([0, 500000])
    const [filtroCuotas, setFiltroCuotas] = React.useState([0, 72])
    const [nombre, setNombre] = React.useState("");
    const [rows, setRows] = React.useState([]);
    const [cart, setShoppingCart] = React.useState([]);
    const [abreInvertir, setAbreInvertir] = React.useState(false);
    const [inversion_resumen, setResumen] = React.useState([0.00, 0])
    const [abreSolicitud, setAbreSolicitud] = React.useState(false);
    const [mensaje, setMensaje] = React.useState("");
    const [disponible, setDisponible] = React.useState(0)
    const [maximo, setMaximo] = React.useState(0);
    const [maximoReenganche, setMaximoReenganche] = React.useState(0);
    const [procesando, setProcesando] = React.useState(false)
    const [rowsResultado, setRowsResultado] = React.useState([])
    const [abreResultado, setAbreResultado] = React.useState(false)
    const [inversionesAbiertas, setInversionesAbiertas] = React.useState(true)
    const [fechaCierre, setFechaCierre] = React.useState("")
    const [mensajeCierre, setMensajeCierre] = React.useState("")
    const { auth, setAuth } = useAuth();

    const wWidth = window.innerWidth;

    const handleFiltroBalance = (valores) => {
        setFiltroBalance(valores)
    }

    const handleFiltroCuotas = (valores) => {
        setFiltroCuotas(valores)
    }

    const handleNombre = (event) => {
        setNombre(event.target.value)
    }

    const columnas = [
        { id: 'invertido', label: ' ', minWidth: 30 },
        { id: 'invertir', label: 'Invertir?', minWidth: 50 },
        {
            id: 'balance',
            label: 'Balance',
            minWidth: 100,
            align: 'right',
            format: (value) => value.toLocaleString('en-US'),
        },
        {
            id: 'disponible',
            label: 'Disponible',
            minWidth: 100,
            align: 'right',
            format: (value) => value.toLocaleString('en-US'),
        },
        {
            id: 'cuotas',
            label: 'Cuotas',
            minWidth: 70,
            align: 'right',
            format: (value) => value.toFixed(2),
        },
    ];

    const shoppingCart = (id, monto) => {
        let ncart = [...cart];
        let existe = false;
        for (var i = 0; i < ncart.length; i++) {
            if (ncart[i].id == id) {
                ncart[i].monto = parseFloat(monto);
                existe = true;
                break;
            }
        }

        if (!existe) {
            ncart.push({ id: id, monto: monto })
        }
        registroActual.invertir = (monto > 0 ? true : false);
        registroActual.monto_invertir = monto;
        setShoppingCart(ncart)
    }

    React.useEffect(() => {
        registroActual = { id: 0, nombre: '', empresa: '', balance: 0, disponible: 0, cuotas: 0, reenganche: 0 }
        verificarCierreInversiones()
        getDisponible()
    }, [])

    const verificarCierreInversiones = async () => {
        try {
            const response = await axios.get("dashboard/cierre-inversiones")
            let data = response.data;
            if (data.respuesta === "S") {
                setInversionesAbiertas(data.inversiones_abiertas)
                setFechaCierre(data.fecha_cierre || "")
                if (!data.inversiones_abiertas) {
                    setMensajeCierre(data.mensaje || "El período de inversión está cerrado")
                }
            }
        } catch (error) {
            console.error("Error verificando cierre de inversiones:", error)
        }
    }

    React.useEffect(() => {
        actRows()
    }, [empresa]);
    React.useEffect(() => {
        getDisponible()
    }, [auth.inversionista])
    React.useEffect(() => {
        let r = [...rows]
        actShoppingCart(r)
        setRows(r)
        calculos()
    }, [cart])
    React.useEffect(() => {

    }, [inversion_resumen])

    const calculos = () => {
        let total = 0.00;
        let cantidad = 0;
        for (var i = 0; i < cart.length; i++) {
            if (cart[i].monto > 0) {
                cantidad++;
                total = total + parseFloat(cart[i].monto)
            }
        }

        setResumen([total, cantidad])
    }

    const getDisponible = async () => {
        let mDisponible = 0.00;
        let mMaximo = 0.00;
        let mMaximoReenganche = 0.00;
        const datos = new FormData()
        datos.append("inversionista", auth.inversionista)
        try {
            const response = await axios.post("inversionista/disponible", datos)
            let data = response.data;
            if (data.respuesta == "S") {
                mDisponible = parseFloat(data.disponible)
                mMaximo = parseFloat(data.maximo)
                mMaximoReenganche = parseFloat(data.maximo_reenganche)
            } else {
                console.log(data.mensaje)
            }
        } catch (error) {

        }

        setDisponible(mDisponible);
        setMaximo(mMaximo)
        setMaximoReenganche(mMaximoReenganche)

    }

    const handleOpenInvertir = (event) => {
        setAbreInvertir(true)
    }

    const handleCloseInvertir = (event) => {
        setAbreInvertir(false)
    }

    const actShoppingCart = (r) => {
        //let r = [...rows]
        for (var i = 0; i < r.length; i++) {
            for (var x = 0; x < cart.length; x++) {
                if (cart[x].id == r[i].id) {
                    if (cart[x].monto > 0) {
                        r[i].invertir = true;
                        r[i].monto_invertir = cart[x].monto;
                    } else {
                        r[i].invertir = false;
                        r[i].monto_invertir = 0;
                    }

                    break;
                }
            }
        }
        //setRows(r)
    }

    let actRows = async (inicio) => {
        inicio = inicio || false;
        setProcesando(true)
        let r_rows = []
        registroActual = { indice: 0, id: 0, reenganche: 0, invertir: false, invertido: 0, monto_invertir: 0.00, id: 0, empresa: 0, nombre: '', balance: 0, disponible: 0, cuotas: 0 }
        try {
            const datos = new FormData();
            datos.append("inversionista", auth.inversionista)
            datos.append("empresa", empresa)
            datos.append("monto_desde", filtroBalance[0])
            datos.append("monto_hasta", filtroBalance[1])
            datos.append("cuotas_desde", filtroCuotas[0])
            datos.append("cuotas_hasta", filtroCuotas[1])
            datos.append("nombre", nombre)

            const response = await axios.post("inversiones/disponibles", datos)
            let data = response.data;
            if (data.respuesta == "S") {
                for (var i = 0; i < data.lista.length; i++) {
                    let m_id = data.lista[i].id;
                    let m_empresa = data.lista[i].empresa;
                    let m_nombre = data.lista[i].nombre;
                    let m_balance = data.lista[i].balance;
                    let m_disponible = parseFloat(data.lista[i].disponible);
                    let m_invertido = parseFloat(data.lista[i].invertido);
                    let m_cuotas = data.lista[i].cuotas;
                    let m_reenganche = data.lista[i].reenganche;
                    r_rows.push({ indice: i, id: m_id, reenganche: m_reenganche, invertir: false, invertido: m_invertido, monto_invertir: 0.00, id: data.lista[i].id, empresa: m_empresa, nombre: m_nombre, balance: m_balance, disponible: m_disponible, cuotas: m_cuotas })
                }
            } else {
                console.log(data.mensaje)
            }
        } catch (error) {

        }

        //console.log(r_rows)
        if (!inicio) { actShoppingCart(r_rows) };

        setRows(r_rows)
        setProcesando(false)
    }

    const handleClickAct = () => {
        actRows()
    }

    let handleCambioEmpresa = (cual) => {
        setEmpresa(cual)
    }

    const handleSetRegistroActual = (cual) => {
        registroActual = cual
    }

    const handleChangeInvertir = (id) => {
        let invertido = false;
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].id == id) {
                invertido = rows[i].invertir;
                break;
            }
        }

        if (invertido) {
            shoppingCart(id, 0)
        } else {
            //setIdInvertir(id);
            setAbreInvertir(true)
        }

    }

    const handleEditInvertir = (id) => {
        setAbreInvertir(true)

    }

    const handleGrabaInversion = (monto) => {
        shoppingCart(registroActual.id, monto);
        setAbreInvertir(false)

    }

    const obj_invertir = () => {
        let mMaximo = maximo
        if (abreInvertir) {
            if (registroActual) {
                if (parseInt(registroActual.reenganche) != 0) {
                    mMaximo = maximoReenganche
                }
            }
        }

        return (

            (abreInvertir ? <Invertir open={abreInvertir}
                close={handleCloseInvertir} registro={registroActual}
                maximo={mMaximo}
                graba={handleGrabaInversion} /> : null)
        )
    }

    const puedeSolicitar = () => {
        let resultado = true;
        let total = 0;

        for (var i = 0; i < cart.length; i++) {
            let este = parseFloat(cart[i].monto)
            if (este > 0) {
                total = total + este;
            }
        }

        if (total < 1) {
            resultado = false;
            setMensaje("No ha seleccionado nada")
        } else {
            if (total > disponible) {
                resultado = false;
                setMensaje("No tiene disponible para esta inversion")
            }
        }


        return resultado;
    }

    const handleSolicitar = () => {
        if (puedeSolicitar()) {
            setAbreSolicitud(true)
        }

    }

    const grabar = async () => {
        setProcesando(true)
        try {
            const response = await axios.post("inversiones/inversion", {
                inversionista: auth.inversionista,
                inversiones: JSON.stringify(cart)
            }, {
                headers: { 'Content-Type': 'application/json' }
            })
            let data = response.data;
            if (data.respuesta == "S") {
                setShoppingCart([])
                await actRows(true)
                setAbreSolicitud(false)
                setRowsResultado(JSON.parse(data.rows))
                setAbreResultado(true)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {

        }

        setProcesando(false)
    }

    const grabartmp = async () => {
        setProcesando(true)
        try {
            const response = await axios.post("inversiones/inversiontmp", {
                inversionista: auth.inversionista,
                inversiones: JSON.stringify(cart)
            }, {
                headers: { 'Content-Type': 'application/json' }
            })
            let data = response.data;
            if (data.respuesta == "S") {
                setShoppingCart([])
                await actRows(true)
                setAbreSolicitud(false)
                setRowsResultado(JSON.parse(data.rows))
                setAbreResultado(true)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {

        }

        setProcesando(false)
    }

    const obj_resultado = () => {
        return (
            <Dialog
                open={abreResultado}
                fullWidth
                fullScreen={isMobile}
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        m: isMobile ? 0 : 2,
                        maxHeight: isMobile ? '100%' : '90vh'
                    }
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    py: isMobile ? 1.5 : 2,
                    fontSize: isMobile ? '1rem' : '1.25rem'
                }}>
                    Detalle Invertido
                </DialogTitle>
                <Container sx={{ py: 2, px: isMobile ? 1 : 2 }}>
                    <table className={isMobile ? 'resultado-tabla-mobile' : 'resultado-tabla'}>
                        <thead>
                            <tr>
                                {!isMobile && <th>Empresa</th>}
                                <th>Nombre</th>
                                <th>Invertido</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                rowsResultado.map((row, index) => {
                                    return (
                                        <tr key={index}>
                                            {!isMobile && <td>{row.empresa}</td>}
                                            <td>{isMobile ? `${row.empresa} - ${row.nombre}` : row.nombre}</td>
                                            <td style={{ textAlign: 'right' }}>{parseFloat(row.invertido).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Container>
                <DialogActions sx={{ p: isMobile ? 1.5 : 2 }}>
                    <Button
                        onClick={() => setAbreResultado(false)}
                        variant="contained"
                        fullWidth={isMobile}
                        sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                            }
                        }}
                    >
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const obj_solicitar = () => {
        return (
            <Dialog
                open={abreSolicitud}
                maxWidth="xs"
                fullWidth
                fullScreen={isMobile}
                PaperProps={{
                    sx: {
                        m: isMobile ? 0 : 2,
                        maxHeight: isMobile ? '100%' : '90vh'
                    }
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    py: isMobile ? 1.5 : 2,
                    fontSize: isMobile ? '1rem' : '1.25rem'
                }}>
                    Confirmacion
                </DialogTitle>
                <Container sx={{ py: 2 }}>
                    <Box padding={isMobile ? 2 : 4}>
                        <Box borderBottom={"2px solid #d4af37"} pb={2} mb={2}>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Box display={"flex"} justifyContent={"flex-end"} paddingTop={"6px"}>
                                        <Typography variant='body2' sx={{ color: '#4a5568' }}>Mi disponibilidad:</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant='h6' sx={{ color: '#1e3a5f', fontWeight: 'bold' }}>
                                        {parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Box display={"flex"} justifyContent={"flex-end"} paddingTop={"2px"}>
                                    <Typography variant='caption' sx={{ color: '#4a5568' }}>Cantidad:</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='body1' sx={{ color: '#1e3a5f' }}>{inversion_resumen[1]}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Box display={"flex"} justifyContent={"flex-end"} paddingTop={"6px"}>
                                    <Typography variant='caption' sx={{ color: '#4a5568' }}>Total:</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='h6' sx={{ color: '#d4af37', fontWeight: 'bold' }}>
                                    {inversion_resumen[0].toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Box display={"flex"} marginTop={4} justifyContent={"center"} gap={2} flexDirection={isMobile ? 'column' : 'row'}>
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={() => setAbreSolicitud(false)}
                                fullWidth={isMobile}
                                sx={{
                                    color: '#1e3a5f',
                                    borderColor: '#1e3a5f',
                                    order: isMobile ? 2 : 1
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                onClick={handleConfirmar}
                                fullWidth={isMobile}
                                sx={{
                                    order: isMobile ? 1 : 2,
                                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                                    }
                                }}
                            >
                                Confirmar
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Dialog>
        )
    }

    const handleConfirmar = () => {
        if (puedeSolicitar()) {
            grabar()
        }
    }

    const obj_mensaje = () => {
        return (
            <Alert severity="error" onClose={() => { setMensaje("") }}>
                <AlertTitle>Error</AlertTitle>
                <strong>{mensaje}</strong>
            </Alert>
        )
    }

    const obj_wait = () => {
        return (
            (procesando && <Box sx={{ position: 'absolute', left: "0px", width: "100%", top: "0px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>)
        )
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const handleAddInvertir = (cual) => {
        setAbreInvertir(true)
    }

    const delay = (callback, ms) => {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    const searchName = (event) => {
        const target = event.target;
        let busca = target.value.toUpperCase();
        delay(function (e) {
            actRows()

        }, 500)();
    }

    const obj_cierre = () => {
        return (
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
                padding: isMobile ? 2 : 3
            }}>
                <Paper elevation={3} sx={{
                    padding: isMobile ? 3 : 4,
                    textAlign: 'center',
                    maxWidth: 500,
                    backgroundColor: '#fff8e1',
                    border: '2px solid #d4af37'
                }}>
                    <LockIcon sx={{ fontSize: isMobile ? 60 : 80, color: '#1e3a5f', mb: 2 }} />
                    <Typography variant={isMobile ? "h6" : "h5"} sx={{ color: '#1e3a5f', fontWeight: 'bold', mb: 2 }}>
                        Período de Inversión Cerrado
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#555', mb: 2, fontSize: isMobile ? '0.875rem' : '1rem' }}>
                        {mensajeCierre}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#888' }}>
                        Fecha de cierre: {fechaCierre}
                    </Typography>
                </Paper>
            </Box>
        )
    }

    // Renderizar tarjetas para vista móvil
    const renderMobileCards = () => {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                pb: 2
            }}>
                {rows.map((row) => {
                    const invertido = parseFloat(row.invertido);
                    const tieneInversion = invertido > 0;
                    const montoInvertir = row.monto_invertir > 0;

                    return (
                        <Card
                            key={row.id}
                            onClick={() => {
                                registroActual = row;
                            }}
                            sx={{
                                border: row.invertir ? '2px solid #d4af37' : '1px solid rgba(30, 58, 95, 0.1)',
                                borderRadius: 2,
                                backgroundColor: row.invertir ? 'rgba(212, 175, 55, 0.05)' : '#fff',
                                boxShadow: '0 2px 8px rgba(30, 58, 95, 0.08)',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                {/* Header con indicadores */}
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', mb: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        {tieneInversion && (
                                            <Chip
                                                icon={<InvertidoIcon sx={{ fontSize: '0.9rem' }} />}
                                                label={parseFloat(invertido).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'rgba(212, 175, 55, 0.2)',
                                                    color: '#1e3a5f',
                                                    fontSize: '0.7rem',
                                                    height: '24px'
                                                }}
                                            />
                                        )}
                                        {tieneInversion && parseInt(row.reenganche) !== 0 && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    registroActual = row;
                                                    handleAddInvertir(row.id);
                                                }}
                                                sx={{ color: '#1e3a5f', p: 0.5 }}
                                            >
                                                <AddCircleOutlineIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Box>
                                </Box>

                                {/* Datos principales */}
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: 1,
                                    mb: 1.5,
                                    py: 1,
                                    borderTop: '1px solid rgba(30, 58, 95, 0.08)',
                                    borderBottom: '1px solid rgba(30, 58, 95, 0.08)'
                                }}>
                                    <Box>
                                        <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase' }}>
                                            Balance
                                        </Typography>
                                        <Typography sx={{ color: '#1e3a5f', fontWeight: 600, fontSize: '0.85rem' }}>
                                            {parseFloat(row.balance).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase' }}>
                                            Disponible
                                        </Typography>
                                        <Typography sx={{ color: '#2c5282', fontWeight: 600, fontSize: '0.85rem' }}>
                                            {parseFloat(row.disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase' }}>
                                            Cuotas
                                        </Typography>
                                        <Typography sx={{ color: '#1e3a5f', fontWeight: 500, fontSize: '0.85rem' }}>
                                            {row.cuotas}
                                        </Typography>
                                    </Box>
                                    {montoInvertir && (
                                        <Box>
                                            <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase' }}>
                                                A Invertir
                                            </Typography>
                                            <Typography sx={{ color: '#d4af37', fontWeight: 700, fontSize: '0.85rem' }}>
                                                {row.monto_invertir.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                                {/* Acciones */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Switch
                                            disabled={tieneInversion}
                                            checked={row.invertir}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                registroActual = row;
                                                handleChangeInvertir(row.id);
                                            }}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#d4af37'
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#d4af37'
                                                }
                                            }}
                                        />
                                        <Typography sx={{ fontSize: '0.75rem', color: '#4a5568' }}>
                                            {tieneInversion ? 'Ya invertido' : 'Invertir'}
                                        </Typography>
                                    </Box>
                                    {montoInvertir && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                registroActual = row;
                                                handleEditInvertir(row.id);
                                            }}
                                            sx={{ color: '#1e3a5f' }}
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>
        );
    };

    if (!inversionesAbiertas) {
        return (
            <div className='busqueda-cuerpo'>
                {obj_cierre()}
            </div>
        )
    }

    return (
        <div className={isMobile ? 'busqueda-cuerpo-mobile' : 'busqueda-cuerpo'}>
            {(mensaje.length > 0 ? obj_mensaje() : null)}
            {objWait()}
            {obj_solicitar()}
            {obj_invertir()}
            {obj_resultado()}

            {/* Header móvil */}
            {isMobile ? (
                <Box sx={{
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    borderRadius: 2,
                    p: 1.5,
                    mb: 1.5,
                    border: '1px solid rgba(30, 58, 95, 0.1)',
                    boxShadow: '0 2px 8px rgba(30, 58, 95, 0.08)'
                }}>
                    {/* Resumen en chips */}
                    <Box sx={{ display: 'flex', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
                        <Chip
                            label={`Disponible: ${parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
                            size="small"
                            sx={{
                                backgroundColor: 'rgba(30, 58, 95, 0.1)',
                                color: '#1e3a5f',
                                fontWeight: 600,
                                fontSize: '0.7rem'
                            }}
                        />
                        <Chip
                            label={`Selección: ${inversion_resumen[0].toLocaleString('en-US', { minimumFractionDigits: 2 })} (${inversion_resumen[1]})`}
                            size="small"
                            sx={{
                                backgroundColor: inversion_resumen[1] > 0 ? 'rgba(212, 175, 55, 0.2)' : 'rgba(30, 58, 95, 0.1)',
                                color: inversion_resumen[1] > 0 ? '#d4af37' : '#1e3a5f',
                                fontWeight: 600,
                                fontSize: '0.7rem'
                            }}
                        />
                    </Box>
                    {/* Buscador y botón */}
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <TextField
                            fullWidth
                            id="filtro-nombre"
                            autoComplete="off"
                            label="Buscar..."
                            type="search"
                            value={nombre}
                            onChange={handleNombre}
                            onKeyUp={searchName}
                            size="small"
                            sx={{ flex: 1 }}
                        />
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleSolicitar}
                            disabled={inversion_resumen[1] === 0}
                            sx={{
                                minWidth: '80px',
                                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                                },
                                '& .MuiButton-label, &': {
                                    color: 'white'
                                }
                            }}
                        >
                            <span style={{ color: 'white' }}>Procesar</span>
                        </Button>
                    </Box>
                </Box>
            ) : (
                <div style={{ paddingTop: "4px" }}>
                    <div className="busqueda-header">
                        <div className='busqueda-header-busqueda'>
                            <TextField fullWidth id="filtro-nombre" autoComplete="off" label="Buscar..." type="search" value={nombre} onChange={handleNombre} onKeyUp={searchName} size="small" />
                        </div>
                        <div className="busqueda-header-disponible">
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-disabled"
                                label="Mi disponible"
                                value={parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                InputLabelProps={{
                                    readOnly: true
                                }}
                            />
                        </div>
                        <div className="busqueda-header-seleccion">
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-disabled"
                                label="Esta seleccion..."
                                value={inversion_resumen[0].toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{"(" + inversion_resumen[1].toString() + ")"}</InputAdornment>,
                                    readOnly: true
                                }}
                            />
                        </div>
                        <div className="busqueda-header-boton">
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleSolicitar}
                                sx={{
                                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                                    }
                                }}
                            >
                                Procesar
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            {/* Contenido principal */}
            {isMobile ? (
                <Box className="busqueda-lista-mobile">
                    {renderMobileCards()}
                </Box>
            ) : (
                <div className="busqueda-tabla">
                    <Tabla columnas={columnas} rows={rows} setRegistroActual={handleSetRegistroActual} changeInvertir={handleChangeInvertir} editInvertir={handleEditInvertir} addInvertir={handleAddInvertir} />
                </div>
            )}
        </div>
    )
}